import axios from 'axios'

export default {
	state: {
		articles: {
			isLoading: false,
			list: [],
		},

		chapters: {
			isLoading: false,
			list: [],
		},
	},

	mutations: {
		SET_IS_LOADING_ARTICLES: (state, isLoading = true) =>
			(state.articles.isLoading = isLoading),
		SET_IS_LOADING_CHAPTERS: (state, isLoading = true) =>
			(state.chapters.isLoading = isLoading),

		SET_ARTICLES: (state, articlesList) =>
			(state.articles.list = articlesList),
		SET_CHAPTERS: (state, chaptersList) =>
			(state.chapters.list = chaptersList),

		SET_CHAPTER_CONTENT: (state, { articleId, chapterId, content }) => {
			let foundChapter = state.chapters.list.find(
				chapter =>
					chapter.id === chapterId &&
					chapter.article.id === articleId,
			)

			foundChapter.content = content
		},
	},

	actions: {
		requestAllArticles: ({ state, rootState, commit }) => {
			if (state.articles.isLoading) return
			commit('SET_IS_LOADING_ARTICLES')

			axios
				.get(`${rootState.App.api.address}/blog/articles`)
				.then(response => {
					commit('SET_ARTICLES', response.data.data)
					commit('SET_IS_LOADING_ARTICLES', false)
				})
		},

		requestAllChapters: ({ rootState, commit }) => {
			commit('SET_IS_LOADING_CHAPTERS')

			axios
				.get(`${rootState.App.api.address}/blog/articles/chapters`)
				.then(response => {
					commit('SET_CHAPTERS', response.data)
					commit('SET_IS_LOADING_CHAPTERS', false)
				})
		},

		requestChaptersByArticle: ({ rootState, commit }, articleId) => {
			commit('SET_IS_LOADING_CHAPTERS')

			axios
				.get(
					`${rootState.App.api.address}/blog/articles/${articleId}/chapters`,
				)
				.then(response => {
					commit('SET_CHAPTERS', response.data.data)
					commit('SET_IS_LOADING_CHAPTERS', false)
				})
		},

		requestChapterContent: (
			{ rootState, commit },
			{ articleId, chapterId },
		) => {
			commit('SET_IS_LOADING_CHAPTERS')

			axios
				.get(
					`${rootState.App.api.address}/blog/articles/${articleId}/chapters/${chapterId}`,
				)
				.then(response => {
					// check for content
					console.log(response.data.data)

					commit('SET_CHAPTER_CONTENT', {
						articleId,
						chapterId,
						content: response.data.data.content,
					})

					commit('SET_IS_LOADING_CHAPTERS', false)
				})
		},
	},

	getters: {
		filterChaptersByArticle: state => articleId =>
			state.chapters.list
				.filter(chapter => chapter.article.id === articleId)
				.map(chapter => ({
					id: chapter.id,
					name: chapter.name,
				})),

		findArticleById: state => articleId =>
			state.articles.list.find(article => article.id === articleId),

		findChapterByParentIds: state => (articleId, chapterId) =>
			state.chapters.list.find(
				chapter =>
					chapter.article.id === articleId &&
					chapter.id === chapterId,
			),
	},
}
